"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.by = void 0;
function by(key, directionOrComparison = 'asc') {
    const propCompare = (() => {
        if (typeof directionOrComparison === 'function') {
            return directionOrComparison;
        }
        if (directionOrComparison === 'desc') {
            return (a, b) => typeof b === 'number'
                ? b - a
                : b.localeCompare(a);
        }
        return (a, b) => typeof a === 'number'
            ? a - b
            : a.localeCompare(b);
    })();
    return (a, b) => propCompare(a[key], b[key]);
}
exports.by = by;
